import { Navigate } from "react-router";
import { usePage } from "../providers/use-page";

export const DefaultRouteRedirect = () => {
  const { rootPath } = usePage();

  return <Navigate to={rootPath} replace />;
};
